import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

class OrderSummaryItem extends PureComponent {
  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    primaryInfo: PropTypes.string,
    secondaryInfo: PropTypes.string,
    stageEditable: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
    extraClass: PropTypes.string,
  }

  static defaultProps = {
    icon: '',
    title: null,
    primaryInfo: null,
    secondaryInfo: null,
    stageEditable: false,
    onClick: null,
    children: null,
    extraClass: '',
  }

  render() {
    const iconTypes = {
      plan: 'kgn-icon-dashboard',
      truck: 'kgn-icon-truck',
      house: 'kgn-icon-house-wireless',
      person: 'kgn-icon-user',
      identification: 'kgn-icon-drivers-license-o',
      none: '',
    }

    const {
      icon,
      title,
      primaryInfo,
      secondaryInfo,
      stageEditable,
      onClick,
      children,
      extraClass,
    } = this.props

    if (title === null || !primaryInfo) {
      // secondary info is allowed to be null
      return null
    }
    const iconClass = iconTypes[icon]

    return (
      <div className={`${extraClass} ${styles.wrapper}`}>
        <i className={`${iconClass} ${styles.icon}`} />
        <div className={styles.itemContainer}>
          <h2 className={styles.heading}>{title}</h2>
          { primaryInfo &&
            <div className={styles.itemInfoMain}>{primaryInfo}</div>
          }
          <div
            className={`secondaryInfo ${styles.itemInfoSecondary}`}
            dangerouslySetInnerHTML={{ __html: secondaryInfo }}
          />
          { children }
          { onClick && stageEditable &&
            <button className={styles.editButton} onClick={onClick}>Edit</button>
          }
        </div>
      </div>
    )
  }
}

export default OrderSummaryItem



// WEBPACK FOOTER //
// ./components/OrderSummaryItem/index.jsx